// src/components/admin/HelpContentManagement.js
import React, { useState } from 'react';
import { usePageTitle } from '../../hooks/usePageTitle';
import HelpTopicsManagement from './HelpTopicsManagement';
import HelpFaqsManagement from './HelpFaqsManagement';
import SupportSettingsManagement from './SupportSettingsManagement';
import AppBrandingSettingsManagement from './AppBrandingSettingsManagement';

const HelpContentManagement = () => {
    usePageTitle('Help & Support Content');

    const tabs = [
        { id: 'topics', label: 'Help Topics', icon: 'fas fa-book' },
        { id: 'faqs', label: 'FAQs', icon: 'fas fa-question-circle' },
        { id: 'support', label: 'Support Settings', icon: 'fas fa-headset' },
        { id: 'branding', label: 'Branding & Legal', icon: 'fas fa-palette' }
    ];

    const [activeTab, setActiveTab] = useState(tabs[0].id);

    const renderTabContent = () => {
        switch (activeTab) {
            case 'topics':
                return <HelpTopicsManagement />;
            case 'faqs':
                return <HelpFaqsManagement />;
            case 'support':
                return <SupportSettingsManagement />;
            case 'branding':
                return <AppBrandingSettingsManagement />;
            default:
                return null;
        }
    };

    return (
        <div className="help-content-page">
            <div className="page-header">
                <div className="header-content">
                    <h1 className="page-title">
                        <i className="fas fa-life-ring"></i>
                        Help & Support Content
                    </h1>
                    <p className="page-description">
                        Manage the Help Topics, FAQs, and Contact Support details shown in the mobile app
                    </p>
                </div>
            </div>

            <div className="settings-container">
                <div className="settings-tabs">
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            className={`settings-tab ${activeTab === tab.id ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            <i className={tab.icon}></i>
                            <span>{tab.label}</span>
                        </button>
                    ))}
                </div>

                <div className="settings-content">
                    {renderTabContent()}
                </div>
            </div>

            <style jsx>{`
                .help-content-page {
                    padding: 2rem;
                    max-width: 1400px;
                    margin: 0 auto;
                }

                .page-header {
                    margin-bottom: 2rem;
                }

                .header-content {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    padding: 2rem;
                    border-radius: 16px;
                    color: white;
                    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
                }

                .page-title {
                    font-size: 2rem;
                    font-weight: 700;
                    margin: 0 0 0.5rem 0;
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                }

                .page-title i {
                    font-size: 1.75rem;
                }

                .page-description {
                    margin: 0;
                    font-size: 1.1rem;
                    opacity: 0.95;
                    color: white;
                }

                .settings-container {
                    background: white;
                    border-radius: 16px;
                    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
                    overflow: hidden;
                }

                .settings-tabs {
                    display: flex;
                    background: #f8f9fa;
                    border-bottom: 2px solid #e9ecef;
                    padding: 0.4rem;
                    gap: 0.5rem;
                    overflow-x: auto;
                    overflow-y: hidden;
                    white-space: nowrap;
                    scrollbar-width: thin;
                }

                .settings-tab {
                    flex: 0 0 auto;
                    min-width: 140px;
                    padding: 0.7rem 0.9rem;
                    background: transparent;
                    border: none;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 0.75rem;
                    font-size: 0.92rem;
                    font-weight: 600;
                    color: #6c757d;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }

                .settings-tab:hover {
                    background: rgba(102, 126, 234, 0.1);
                    color: #667eea;
                }

                .settings-tab.active {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    color: white;
                    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
                }

                .settings-tab i {
                    font-size: 1.2rem;
                }

                .settings-content {
                    padding: 2rem;
                    min-height: 500px;
                }

                @media (max-width: 768px) {
                    .help-content-page {
                        padding: 1rem;
                    }

                    .settings-tabs {
                        flex-direction: row;
                        gap: 0.4rem;
                    }

                    .settings-tab {
                        justify-content: center;
                        min-width: 125px;
                        padding: 0.6rem 0.75rem;
                    }

                    .settings-content {
                        padding: 1.5rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default HelpContentManagement;
